// Phase 9 R2 — Stock status pill (Out / Low) — thresholds match server filter.
import { Badge } from '@/components/ui/badge';

export function getStockStatus(available: number, reorderPoint: number): 'ok' | 'low' | 'out' {
  if (available <= 0) return 'out';
  if (available <= reorderPoint) return 'low';
  return 'ok';
}

export function StockPill({
  available,
  reorderPoint,
}: {
  available: number;
  reorderPoint: number;
}) {
  const status = getStockStatus(available, reorderPoint);
  if (status === 'ok') return null;
  if (status === 'out') {
    return <Badge variant="destructive">Out of Stock</Badge>;
  }
  return (
    <Badge variant="outline" className="border-warning text-warning">
      Low Stock
    </Badge>
  );
}
